import React from 'react';
import Autocomplete, {
    createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import { Box } from '@material-ui/core';
import { useStyles } from 'src/common/components/form/autocomplete/AutoComplete.styled';
import Close from 'src/assets/images/CloseProduct.svg';
import { useTranslation } from 'react-i18next';

const ReportAutoComplete = ({
    optionValue,
    optionLabelKey,
    renderInput,
    renderOption,
    onInputChange,
    onClose,
    onChange,
    onOpen,
    open,
    optionData,
    noOptionsText,
    closeIconDisplay,
    onFocus,
    onBlur,
    closeAction,
    isShipToAddress,
    defaultValue, 
    ...props
}) => {
    const { t } = useTranslation();
    noOptionsText = noOptionsText || t('common.noResultFoundText');

    // useEffectWithErrorLogging(() => {
    //     const close = document.getElementsByClassName(
    //         'MuiSvgIcon-fontSizeSmall'
    //     )[0];
    //     if (close) {
    //         close.style.height = '25px';
    //         close.style.fontSize = '25px';
    //         close.style.marginTop = '-3px';
    //         close.style.opacity = '0.7px';
    //         close.style.marginRight = '-10px';
    //     }
    //     const clear = document.getElementsByClassName(
    //         'MuiAutocomplete-clearIndicator'
    //     )[0];
    //     if (clear) {
    //         clear.style.backgroundColor = '#ffffff';
    //     }
    // }, []);

    const filterOptions = createFilterOptions({
        trim: true,
        stringify: props.isDefaultFilterOptions
            ? (option) => (option ? option[optionValue] : option[optionValue])
            : ({ cfn, description }) => `${cfn} ${description}` || '',
    });

    const classes = useStyles({
        zIndex: props.zIndex,
        hoverBgColor: props.hoverBgColor,
        closeIconDisplay: closeIconDisplay,
        dropdownHeight: props.dropdownHeight,
    });

    return (
        <React.Fragment>
            <Box>
                <Autocomplete 
                    className="full-width-autocomplete"
                    freeSolo
                    // filterOptions={filterOptions}
                    defaultValue={isShipToAddress? defaultValue?defaultValue:null:null}
                    filterOptions={ isShipToAddress? (options) => options: filterOptions}
                    id="custom-input-demo"
                    options={optionData}
                    loading={props.loading}
                    getOptionLabel={(option) =>
                        option
                            ? optionLabelKey != ''
                                ? option[`${optionLabelKey}`]
                                : ''
                            : ''
                    }
                    onChange={(_event, value, isClear) => {
                        onChange(_event, value, isClear);
                    }}
                    onInputChange={(e, value, reason) => {
                        onInputChange(e, value, reason);
                    }}
                    noOptionsText={noOptionsText}
                    onOpen={onOpen}
                    open={open}
                    onClose={onClose}
                    getOptionSelected={(option, value) =>
                        option &&
                        value &&
                        option[`${optionValue}`] == value[`${optionValue}`]
                    }
                    disableUnderline={true}
                    disabled={props.disabled}
                    renderInput={(option) => renderInput(option)}
                    renderOption={(params) => renderOption(params)}
                    clearOnEscape={true}
                    classes={{
                        listbox: props.showScrollBar
                            ? classes.listRoot
                            : props.dropdownHeight
                            ? classes.dynamicHeight
                            : '',
                        popper: classes.popper,
                        option: classes.options,
                        endAdornment: classes.endAdornment,
                    }}
                    closeIcon={
                        <img
                            id={props.closeIconId} 
                            height={'15px'}
                            src={Close}
                            onClick={closeAction}
                        ></img>
                    }
                    onFocus={onFocus}
                    onBlur={onBlur}
                    {...props}
                />
            </Box>
        </React.Fragment>
    );
};

ReportAutoComplete.defaultProps = {
    isDefaultFilterOptions: false,
};

export default ReportAutoComplete;
